import { createLoggedOutAppContext } from '../../shared/source/components/app-context/create-logged-out-app-context.tsx';
import { getOrSetGlobalAppContext } from '../../shared/source/components/app-context/global-app-context.tsx';

getOrSetGlobalAppContext(() => createLoggedOutAppContext());
